/* eslint-disable prettier/prettier */

export enum TrackingEventsEnum {
    StartSignup = 'StartSignup',
    CompleteRegistration = 'CompleteRegistration',
    InitiateCheckout = 'InitiateCheckout',
    CompleteCheckout = 'CompleteCheckout',
    Recaptcha_Clicked = 'Recaptcha_Clicked',
    Recaptcha_Success = 'Recaptcha_Success',
    Recaptcha_Failed = 'Recaptcha_Failed',
}